import React, { useEffect, useState, Component } from 'react';

import Switch from '@material-ui/core/Switch';
import { Link } from 'react-router-dom';
import { Grid, Typography } from '@material-ui/core';
import FirebaseService from '../../../services/firebase';
import Contact from './contact';
import InfiniteScroll from 'react-infinite-scroll-component';

import { List, AutoSizer } from "react-virtualized";
import { CloseButton, Form, Spinner } from 'react-bootstrap';


const Contacts = (props) => {

    const [contactSelected, setContactSelected] = useState(null);
    const [contactList, setContactList] = useState([]);
    const [search, setSearch] = useState('');
    const [typingTimeout, setTypingTimeout] = useState(0);
    const [loading, setLoading] = useState(false);
    const rowHeight = 65;

    const handleSelect = (contact) => {
        setContactSelected(contact.id)
        props.select(contact)
        FirebaseService.updateContact(contact.userId, contact.id, { unreadMessages: 0 })
    }

    const renderRow = ({ index, key, style }) => {
        const contacts = search ? contactList : props.contacts
        return (
            <button
                key={contacts[index].id}
                style={style}
                className={`contact-btn ${contacts[index].id == contactSelected ? 'selected' : ''}`}
                onClick={() => handleSelect(contacts[index])}>
                <Contact contact={contacts[index]} selected={contacts[index].id == contactSelected} />
            </button>
        );
    }

    const resize = ({ width, height }) => {
        return <List
            width={width}
            height={height}
            rowHeight={rowHeight}
            rowRenderer={renderRow}
            rowCount={search ? contactList.length : props.contacts.length}
            overscanRowCount={5} />
    }

    const searchContact = (value) => {
        setSearch(value);

        if (typingTimeout) {
            clearTimeout(typingTimeout);
        }

        if (value.length === 0) {
            setContactList([]);
            setLoading(false)
            return;
        }

        setLoading(true)

        setTypingTimeout(setTimeout(() => {
            findContacts(value);
        }, 500))
    }

    const findContacts = async (name) => {
        let contacts = await (FirebaseService.findContacts(name).get());
        if (contacts) {
            contacts = contacts.docs.map(contact => contact.id)
            let contactsFiltered = props.contacts.filter(contact => contacts.indexOf(contact.contactId) >= 0)
            setContactList(contactsFiltered)
            setLoading(false)
        }
    }

    return (
        <div className="contact-component">
            <Form className="contact-component-search mb-0" autoComplete="off">
                <Form.Group className="contact-component-search-field mb-0" controlId="searchContact">
                    <Form.Control className="mb-3" type="text" value={search} placeholder="Pesquisar contato" onChange={(data) => searchContact(data.target.value)} />
                    <CloseButton className="search-cancel-btn" onClick={() => searchContact('')} />
                </Form.Group>
            </Form>
            <div className="contact-list">
                {loading ? <Spinner style={{ marginLeft: 140 }} animation="border" /> : <AutoSizer>{resize}</AutoSizer>}
            </div>
        </div>
    )
}

export default Contacts;